<template>
  <v-dialog
    v-model="automationPayoutDialog"
    width="540"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('withdrawals.automatedPayout.title') }}</b>
      </v-card-title>
      
      <v-card-text
        class="mt-2"
      >
        <template v-if="showSuccessful">
          <div class="description">
            {{ $t('withdrawals.automatedPayout.successful') }}
          </div>
        </template>
        <template v-else>
          <div class="description">
            {{ $t('withdrawals.automatedPayout.description') }}
          </div>
          <v-flex mt-4>
            <small>{{ $t('withdrawals.amount') }}</small><br>
            <b>{{ withdrawal.amount }} {{ withdrawal.currency }}</b>
          </v-flex>
          <v-flex mt-4>
            <small>{{ $t('withdrawals.blockchain') }}</small><br>
            <b>{{ withdrawal.blockchain }}</b>
          </v-flex>
        </template>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="automationPayoutDialog = false"
        >
          <span>{{ showSuccessful?$t('globals.closeButton'):$t('withdrawals.automatedPayout.cancel') }}</span>
        </v-btn>
        <v-btn
          v-if="!showSuccessful"
          color="primary"
          @click="confirm()"
        >
          {{ $t('withdrawals.automatedPayout.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  required,
} from "vuelidate/lib/validators"
import PROCESS_WITHDRAWAL_MUTATION from "@/graphql/mutations/ProcessWithdrawal.gql";

export default {
  name: "AutomatedPayoutDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    withdrawal: {
      type: Object,
      default() {
        return null;
      }
    },
  },
  data() {
    return {
      showSuccessful: false,
      loading: false,
    };
  },
  validations() {
    return {
      form: {
        network: {
          required,
        }
      },
    };
  },
  computed: {
    automationPayoutDialog: {
      get() {
        return this.showDialog;
      },
      set() {
        this.$emit('closeAutomatedPayoutDialog', false);
      }
    },
    NetworkErrors() {
      const errors = [];
      if (!this.$v.form.network.$dirty) return errors;
      !this.$v.form.network.required && errors.push(this.$t("projects.reqField"));
      return errors;
    }
  },
  methods: {
    confirm() {
      const form = {id: this.withdrawal.id, auto_process: true}
      this.$apollo
          .mutate({
            mutation: PROCESS_WITHDRAWAL_MUTATION,
            variables: form
          })
          .then(() => {
            this.loading = false;
            this.withdrawal.status = 'pending'
            this.showSuccessful = true;
          })
          .catch(error => {
            this.errorHandler(error);
            this.loading = false;
          });
    }
  },
};
</script>

<style lang="scss" >
</style>
